import { appNoOp, appSetAutoSearch } from '@actions/app.action';
import { updateSelectedCurrencyCode } from '@actions/culture.action';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, map } from 'rxjs';

@Injectable()
export class CultureEffect {
  constructor(private actions$: Actions) {}

  updateCurrencyCode$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(updateSelectedCurrencyCode),
      map((action) => {
        if (action.isFlightsPage) {
          return appSetAutoSearch({ payload: { search: true } });
        } else {
          return appNoOp();
        }
      }),
    );
  });
}
